export default "__VITE_ASSET__D9c15wug__"